import { Heading, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { ProductType, StoreProductsList } from '@/entities/product';
import { DefaultContainer } from '@/shared/ui';
import { MetaDecorator } from '@/shared/utils';

type StoreProductsPageProps = {
  products: ProductType[];
};

const StoreProductsPage = ({ products }: StoreProductsPageProps) => {
  const { t } = useTranslation();

  return (
    <>
      <MetaDecorator
        description='meta.store.products.description'
        title='meta.store.products.title'
      />

      <DefaultContainer>
        <VStack
          spacing='8'
          textAlign='center'
        >
          <VStack spacing='4'>
            <Heading
              as='h1'
              fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
              fontWeight='bold'
            >
              {t('store.products.listHeading')}
            </Heading>
            <Text
              color='gray.600'
              fontSize='lg'
              maxW='2xl'
            >
              {t('store.products.listDescription')}
            </Text>
          </VStack>

          <StoreProductsList products={products} />
        </VStack>
      </DefaultContainer>
    </>
  );
};

export type { StoreProductsPageProps };
export default StoreProductsPage;
